export default __webpack_public_path__ + "static/media/project_etc.74ed259f.svg";